import React from "react";
import {convertBalance} from "../../utils";
import Separator from "./Separator/Separator";

function LockRow({lock, last}) {
    //console.log(lock.endTimestamp);
    //console.log(lock.endTimestamp.toString());
    //console.log(lock.endTimestamp.toNumber());

    const displayStartDate = React.useCallback(() => {
        if(Object.prototype.hasOwnProperty.call(lock, "endTimestamp")) {
            const startDate = new Date(lock.endTimestamp * 1000);
            startDate.setFullYear( startDate.getFullYear() - 1 );
            return startDate.toLocaleString();
        } else {
            return "-";
        }
    }, [lock]);


    return (
        <div style={{marginTop: 20, width: "100%"}}>
            <div style={{display: "flex"}}>
                <span style={{width: 300, color: "var(--grey0)"}}>{displayStartDate()}</span>
                <span style={{width: 200, color: "var(--grey0)"}}>{lock.type}</span>
                <span style={{flexGrow: 1, fontWeight: "bold"}}>{convertBalance(lock.amount)}</span>
            </div>
            {!last && <Separator light />}
        </div>
    )
}

export default LockRow;
